import React from 'react';
import { RouteComponentProps, Link } from '@reach/router';
import Result from 'antd/lib/result';
import 'antd/lib/result/style';
import Button from 'antd/lib/button';
import 'antd/lib/button/style';
import Authorized from '@/components/Authorized';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/reducers';
import appRoutes from '@/config/routes';
import { getRouteForPath, detectWebApp } from '@/utils';
// import { Device } from '@/redux/reducers/ui';
import env from '@/env';
import './AuthLayout.less';
import HelmetHead from '@/components/HelmetHead/HelmetHead';

export interface AuthLayoutProps extends RouteComponentProps {
  children: React.ReactNode;
}

const UnauthorizedPage = (
  <Result
    status={403}
    title="403"
    subTitle="Sorry, you are not authorized to access this page."
    extra={
      <Button type="primary">
        <Link to="/auth/login">Login</Link>
      </Button>
    }
  />
);

const AuthLayout = (props: AuthLayoutProps) => {
  const { children } = props;
  const webApp = detectWebApp[env.siteId as keyof typeof detectWebApp];
  const authUser = useSelector((state: RootState) => state.authUser.data);
  const organisation = useSelector((state: RootState) => state.organisation.data);
  // const { device } = useSelector((state: RootState) => state.ui);

  const route = getRouteForPath(window.location.pathname, appRoutes);

  return (
    <div className="AuthLayout">
      <HelmetHead title={webApp.siteName} description={webApp.siteName} />
      <div className="AuthLayout-container custom-container">
        <Link to="/">
          {/* {device.type === Device.desktop ? (
            <p className="AuthLayout-title">{`${webApp.appName}${webApp.tld}`}</p>
          ) : ( */}
          <div className="AuthLayout-logo">
            <img src={webApp.logo} alt="Open Banking" />
          </div>
          {/* )} */}
        </Link>
        <div className="AuthLayout-main">
          <Authorized
            authUser={authUser}
            route={route}
            organisationId={organisation?.id}
            unauthorizedPage={UnauthorizedPage}
          >
            {children}
          </Authorized>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
